// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3ygMa","content":"LoadingAlert_content__2TcBx"};